import React, { useContext } from "react";
import {
    Button,
    ButtonGroup,
    MenuItem,
    Text,
    VStack,
    useDisclosure,
} from "@chakra-ui/react";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import InputDialog from "../../../common/components/InputDialog";
import ContentContext from "../../../common/context/ContentContext";
import useDynamicRequest from "../../../common/hooks/useDynamicRequest";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { contentActions } from "../../../store/slices/content";

const DialogueForm = ({
    handleCancel,
    handleDelete,
    title,
}: {
    handleCancel: () => void;
    handleDelete: () => void;
    title: string;
}) => {
    return (
        <VStack spacing={4}>
            <Text fontSize="large">
                Estás a punto de eliminar <b>{title}</b>
            </Text>
            <Text fontSize="large">Esta acción no se puede revertir.</Text>
            <ButtonGroup>
                <Button variant="outline" onClick={handleCancel}>
                    Cancelar
                </Button>
                <Button colorScheme="red" onClick={handleDelete}>
                    Sí, elimina el contenido
                </Button>
            </ButtonGroup>
        </VStack>
    );
};

const DeleteButton = ({ mode }: { mode?: "button" | "menu-item" }) => {
    const content = useContext(ContentContext);
    const { isOpen, onClose, onOpen } = useDisclosure();
    const [_, callDelete] = useDynamicRequest<{}>();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const handleDelete = () => {
        callDelete("DELETE", `/content/${content!._id}`, undefined, {
            onSuccess: (_) => {
                onClose();
                dispatch(contentActions.deleteContentCompleted(content!._id));
                navigate(`/subjects/${content!.subject}/contents`, {
                    replace: true,
                });
            },
        });
    };

    return (
        <>
            {content && (
                <>
                    <InputDialog
                        body={
                            <DialogueForm
                                handleCancel={onClose}
                                handleDelete={handleDelete}
                                title={content.title}
                            />
                        }
                        isOpen={isOpen}
                        onClose={onClose}
                        header={<Text color="red.800">¿Eliminar Contenido?</Text>}
                    />
                    {mode === "menu-item" ? 
                        <MenuItem onClick={onOpen} textColor={"red.600"} icon={<FontAwesomeIcon icon={faTrash} />}>
                            Eliminar Contenido
                        </MenuItem> :
                        <Button
                            colorScheme="red"
                            variant="outline"
                            leftIcon={<FontAwesomeIcon icon={faTrash} />}
                            onClick={onOpen}
                        >
                            Eliminar
                        </Button>
                    }
                </>
            )}
        </>
    );
};

export default DeleteButton;
